import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class EjecutorService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    listWithRelatores() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/ejecutores/with-relatores`, { headers }).toPromise();
    }
    update(user, categoriaId) {
        return this.http.put(`${this.configService.API_URL}/ejecutores/${categoriaId}`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    create(user) {
        return this.http.post(`${this.configService.API_URL}/ejecutores`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getAllCategorias() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/ejecutores`, { headers }).toPromise();
    }
    deleteEjecutor(ejecutorId) {
        return this.http.delete(`${this.configService.API_URL}/ejecutores/${ejecutorId}`, Object.assign({}, this.jsonContent)).toPromise();
    }
}
EjecutorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EjecutorService_Factory() { return new EjecutorService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: EjecutorService, providedIn: "root" });
